$(document).ready(function(){

    $('fieldset legend input').css('cursor', 'pointer');

    $('fieldset legend').on('click', 'input[type="radio"]', function()
    {
        let this_fieldset = $(this).closest('fieldset');
        let parent_el = this_fieldset.parent();

        parent_el.find('fieldset').attr('disabled','');

        this_fieldset.removeAttr('disabled');

        parent_el.find('fieldset legend input').css('cursor', 'pointer');
        parent_el.find('fieldset:disabled .hide-on-disabled').slideUp(500);
        parent_el.find('fieldset:enabled > .hide-on-disabled').slideDown(500);
    }).on('click', 'input[type="checkbox"]', function()
    {
        let this_input = $(this);
        let this_fieldset = this_input.closest('fieldset');
        let parent_el = this_fieldset.parent();


        if(this_input.is(':checked'))
        {
            this_fieldset.removeAttr('disabled');
        }
        else
        {
            this_fieldset.attr('disabled', '');
        }
        parent_el.find('fieldset:disabled .hide-on-disabled').slideUp(500);
        parent_el.find('fieldset:enabled .hide-on-disabled').slideDown(500);
    });

    $('fieldset:disabled .hide-on-disabled').hide();

    $('.datetimepicker').datetimepicker({
        locale: moment.locale('sk'),
        showTodayButton: true,
        collapse: true,
    });

    $('.datepicker').datetimepicker({
        locale: moment.locale('sk'),
        showTodayButton: true,
        collapse: true,
        format: 'DD.MM.YYYY'
    });

    $('.monthpicker').datetimepicker({
        locale: moment.locale('sk'),
        showTodayButton: true,
        collapse: true,
        format: 'MM/YYYY',
        viewMode: 'months'
    });

    $('.datetimepicker,.datepicker').on('focus', 'input', function () {
        $(this).parents('.datetimepicker,.datepicker').data("DateTimePicker").show();
    });
});